import { 
	GET_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCES, 
	GET_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE,
	CREATE_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE,
	UPDATE_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE,
	DESTROY_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE,
} from "./actions"

export function ProjectCommunicationsCustomReferencesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE}_FULFILLED`:
		case `${CREATE_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE}_FULFILLED`:
		case `${UPDATE_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_COMMUNICATIONS_CUSTOM_REFERENCE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectCommunicationsCustomReferencesReducer } from "modules/project/communications/custom_references/reducer"

// project_communications_custom_references:ProjectCommunicationsCustomReferencesReducer,
